<template>
    <div>
        <div id="train-adjust-list">
            <train-adjust-item
                v-for="(item, trainIndex) in trainList"
                :key="item.id"
                :color="getColor(trainIndex)"
                :item="item"
                @on-item-event="handleItemEvent(trainIndex, $event)"
            >
                <template v-slot="{ tasks }">
                    <div :data-gid="trainIndex" class="js-sortable-group">
                        <!-- :class checked 控制是否可以拖动, expanded 控制是否展开运单任务 -->
                        <div
                            v-for="(task, taskIndex) in tasks"
                            :key="task.taskNo"
                            :class="sortableItemClass(item)"
                            :data-iid="taskIndex"
                        >
                            <train-adjust-task
                                :color="getColor(trainIndex)"
                                :disabled="isTaskActionsDisabled(item)"
                                :index="taskIndex"
                                :task="task"
                                :adjustCheckDisable="adjustCheckDisable"
                                @on-delete="
                                    handleTaskDelete(
                                        trainIndex,
                                        taskIndex,
                                        task
                                    )
                                "
                                @on-add="
                                    handleTaskAdd(trainIndex, taskIndex, task)
                                "
                            ></train-adjust-task>
                        </div>
                    </div>
                </template>
            </train-adjust-item>
        </div>
        <span>
            <el-button
                v-if="hasModified && adjustCheckDisable"
                v-has="'otp02020006'"
                class="adjust-item-action"
                type="primary"
                @click="handleConfirmAdjust"
                >确认调整</el-button
            >
        </span>
        <span>
            <el-button
                v-if="hasModified && adjustCheckDisable"
                v-has="'otp02020007'"
                class="adjust-item-action"
                type="primary"
                @click="handleConfirmNewAdjust"
                >确认调整新</el-button
            >
        </span>
        <el-dialog
            title="调整原因"
            :visible.sync="reasionVisible"
            :close-on-click-modal="false"
            :before-close="handleReasionCancel"
            width="500px"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
            >
                <el-form-item label="调整原因类型" prop="adjustReason">
                    <selects
                        :optionNum="'ALGORITHM_ADJUST_REASON'"
                        :mValue="ruleForm.adjustReason"
                        :multiple="true"
                        @getSelectValue="getSelectValue"
                        placeholder="请选择调整原因类型"
                        :prop="'adjustReason'"
                    ></selects>
                </el-form-item>
                <el-form-item
                    label="备注"
                    :prop="
                        ruleForm.adjustReason.includes('7') ||
                        ruleForm.adjustReason.includes('6')
                            ? 'remark'
                            : ''
                    "
                >
                    <el-input
                        type="textarea"
                        :rows="7"
                        clearable
                        maxlength="300"
                        show-word-limit
                        v-model="ruleForm.remark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleReasionCancel">取 消</el-button>
                <el-button type="primary" @click="handleReasionSure"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import TrainAdjustItem from './TrainAdjustItem';
import TrainAdjustTask from './TrainAdjustTask';
import { Sortable } from 'sortablejs';
import lodash from 'lodash';
import { PromiseUtils } from '../utils/promise';
import { TrainEntity } from '../entity/trainEntity';
import selects from '@/components/lots/otpSelect';
import * as api from '../../../../api/trainList';

const { colorByIndex } = require('../utils/colors');

export default {
    name: 'train-adjust-list',
    components: { TrainAdjustItem, TrainAdjustTask, selects },
    props: {
        controller: Object,
        trainList: Array,
        doAddTask: Function,
        doDeleteTask: Function,
        adjustCheckDisable: Boolean
    },
    data () {
        return {
            reasionVisible: false,
            ruleForm: {
                adjustReason: [], // 调整原因类型
                remark: '' // 调整原因备注
            },
            rules: {
                adjustReason: [
                    { required: true, message: '请选择调整原因类型', trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: '请输入备注', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
        hasModified () {
            return this.trainList.filter(t => t.local.modified).length > 0;
        }
    },
    created () {
        // 用于保存sortable分组信息
        this.sortableGroups = [];

        // 绑定 controller
        this.controller._bind(this);

        this.messenger = PromiseUtils.buildErrorMessenger(this.$message);

        /// 实现列表的重新排布, 使 viewModel 状态 与 sortablejs 对DOM修改 进行同步。
        this.handleSortedImpl = lodash.debounce(async (evt) => {
            // 来源/目标 的 分组索引 和 Task 索引
            const [f, t] = [
                { trainIndex: evt.from.dataset.gid, taskIndex: evt.oldIndex },
                { trainIndex: evt.to.dataset.gid, taskIndex: evt.newIndex }
            ];

            // 克隆 trainList
            const clonedTrainList = lodash.cloneDeep(this.trainList);
            try {
                if (f.trainIndex !== t.trainIndex) {
                    // 如果 来源 和 目标 分组 ***不是*** 同一个

                    const targetDispatchFrom = clonedTrainList[f.trainIndex];
                    // 处理 从 源 dispatch item 中删除
                    const [newTasksFrom, taskToDelete, respTrainForDelete] = await this.doDeleteTask(
                        targetDispatchFrom, targetDispatchFrom.tasks[f.taskIndex]);
                    clonedTrainList[f.trainIndex] = respTrainForDelete;
                    clonedTrainList[f.trainIndex].tasks = newTasksFrom;
                    // 重新计算里程数
                    if (newTasksFrom.length) {
                        clonedTrainList[f.trainIndex].mileage = await this.getCalculate(newTasksFrom);
                    }
                    const targetDispatchTo = clonedTrainList[t.trainIndex];
                    // 处理 加入 目标 dispatch item
                    const [newTasks, respTrainForAdd] = await this.doAddTask(targetDispatchTo, taskToDelete, t.taskIndex);
                    clonedTrainList[t.trainIndex] = respTrainForAdd;
                    clonedTrainList[t.trainIndex].tasks = newTasks;
                    // 重新计算里程数
                    if (newTasks.length) {
                        clonedTrainList[t.trainIndex].mileage = await this.getCalculate(newTasks);
                    }
                } else {
                    // 如果 来源 和 目标 分组 是同一个

                    const train = clonedTrainList[f.trainIndex];

                    // 组内移动
                    const pos = train.tasks.splice(f.taskIndex, 1);
                    train.tasks.splice(t.taskIndex, 0, ...pos);
                    train.mileage = await this.getCalculate(train.tasks);
                }

                // 等待 100 毫秒，将克隆的已修改的 trainList 已 on-sort 事件发出
                // 让外部组件重新复制 trainList, 实现状态同步(viewModel <-> DOM)
                setTimeout(() => {
                    this.$emit('on-sort', { from: f, to: t }, clonedTrainList);
                }, 100);
            } catch (e) {
                // hack: 手动操作 DOM 元素，恢复 原状
                evt.from.insertBefore(
                    evt.to.children[evt.newIndex],
                    evt.from.children[evt.oldIndex]);

                this.messenger.w(e);
            }
        }, 200);
    },
    methods: {
        // 获取里程
        async getCalculate (tasks) {
            const params = {
                originAddress: tasks[0].senderDetailAddr,
                destAddresses: tasks.map(i => i.receiverDetailAddr)
            };
            const res = await api.calculate(params);
            if (res && res.code === '0') {
                return res.data;
            } else {
                return 0;
            }
        },
        getSelectValue (data) {
            this.ruleForm = { ...this.ruleForm, ...data };
        },
        handleConfirmNewAdjust () {
            this.ruleForm.adjustReason = [];// 默认为算法不准，跟其他
            this.ruleForm.remark = '';
            this.reasionVisible = true;
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields();
            });
        },
        handleReasionCancel () {
            this.reasionVisible = false;
        },
        handleReasionSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if ((this.ruleForm.adjustReason.includes('6') || this.ruleForm.adjustReason.includes('7')) && !this.ruleForm.remark) {
                        return this.$message.warning('当调整原因类型包含算法不准确/其他时，备注必填');
                    }
                    const data = {
                        adjustReason: this.ruleForm.adjustReason.join(','),
                        remark: this.ruleForm.remark
                    };
                    this.$emit('on-confirm-adjust', data);
                    this.reasionVisible = false;
                } else {
                    return false;
                }
            });
        },
        sortableItemClass (item) {
            return {
                'js-sortable-item': item.local.checked &&
                    (item.local.expanded || item.tasks.length === 1),
                'sortable-item-hidden': !item.local.expanded
            };
        },
        _initSortable () {
            const groupElements = document.querySelectorAll('.js-sortable-group');
            this.sortableGroups = [];
            for (const [i, e] of groupElements.entries()) {
                const options = {
                    animation: 300,
                    draggable: '.js-sortable-item',
                    ghostClass: 'adjust-item-ghost',
                    dragClass: 'adjust-item-dragging',
                    sort: true,
                    group: {
                        name: `group-${this.sortableGroups.length}`,
                        pull: () => {
                            return TrainEntity.statusIsToArrange(this.trainList[i]);
                        },
                        put: () => {
                            return this.trainList[i].local.checked;
                        }
                    },
                    onSort: (evt) => {
                        this.handleSorted(evt);
                    }
                };
                const sg = Sortable.create(e, options);
                this.sortableGroups.push(sg);
            }
        },
        listSortTable () {
            const el = document.getElementById('train-adjust-list');
            const ops = {
                animation: 200,
                group: 'list',
                ghostClass: 'adjust-item-ghost',
                dragClass: 'adjust-item-dragging',
                onEnd: function (evt) {
                }
            };
            Sortable.create(el, ops);
        },
        getColor (idx) {
            return colorByIndex(idx);
        },
        // 运单任务是否可以操作
        isTaskActionsDisabled (train) {
            // (没有check) 或者 (运单数量大于1个且没有展开)
            return !train.local.checked || (train.tasks.length > 1 && !train.local.expanded);
        },
        /// 统一转发 TrainAdjustItem 的事件
        handleItemEvent (index, event) {
            this.$emit(`on-${event.eventName}`, { ...event, index });
        },
        /// Sortablejs on sort 事件
        handleSorted (evt) {
            this.handleSortedImpl(evt);
        },
        /// 删除 Task
        async handleTaskDelete (trainIndex, taskIndex, task) {
            try {
                const clonedDL = lodash.cloneDeep(this.trainList);

                const targetDispatch = clonedDL[trainIndex];

                PromiseUtils.assertSilently(targetDispatch.local.checked);

                // eslint-disable-next-line
                const [newTasks, _, respTrain] = await this.doDeleteTask(targetDispatch, task);
                clonedDL[trainIndex] = respTrain;
                clonedDL[trainIndex].tasks = newTasks;

                this.$emit('on-delete', { trainIndex, taskIndex, task }, clonedDL);
            } catch (e) {
                this.messenger.w(e, '删除失败');
            }
        },
        /// 添加 Task
        handleTaskAdd (trainIndex, taskIndex, task) {
            try {
                PromiseUtils.assertSilently(this.trainList[trainIndex].local.checked);
                this.$emit('on-add', { trainIndex, taskIndex, task });
            } catch (e) {
                this.messenger.w(e, '删除失败');
            }
        },
        /// 确认调整
        handleConfirmAdjust () {
            this.$emit('on-confirm-adjust');
        }
    },
    mounted () {
        this.listSortTable();
    }
};

</script>

<style lang="less">
.adjust-item-ghost {
    background-color: #e7eeef;
}

.adjust-item-dragging {
    background-color: #cfeeef;
    box-shadow: 0 0 0 10px black;
}

.sortable-item-hidden {
    display: none;

    &:first-child {
        display: block;
    }
}
.adjust-item-action {
    float: right;
    margin-right: 20px;
}
</style>
